"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const S3Client_1 = __importDefault(require("client/S3Client"));
const UploadClient_1 = require("client/UploadClient");
const getPresignUrl = async (presignQuery) => {
    const { data } = await (0, UploadClient_1.getPerformancePreSignUrl)(presignQuery);
    if (data) {
        return data;
    }
};
const useS3Upload = () => {
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const [presignUrl, setPresignUrl] = (0, react_1.useState)(null);
    const uploadFile = async ({ file, presignQuery, onSuccess, onError }) => {
        setUploading(true);
        const presignData = await getPresignUrl(presignQuery);
        if (presignData) {
            setPresignUrl(presignData);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const { status } = (await (0, S3Client_1.default)(presignData.uploadUrl, file));
            if (status === 200) {
                onSuccess && (await onSuccess(presignData));
            }
            else {
                onError && (await onError());
            }
        }
        setUploading(false);
    };
    return { uploading, presignUrl, uploadFile };
};
exports.default = useS3Upload;
